export default __webpack_public_path__ + "310e2e1cf69e7f3956e9f98b811554e8.png";